import request from "../../utils/request";
export default {
  newPassword: function newPassword(model) {
    return request('post', 'api/i/v1/policy/iBranchNewPassword', model);
  },
  updatePassword: function updatePassword(model) {
    return request('post', "api/i/v1/policy/passwordUpdate?oldPassword=".concat(model.oldPassword, "&newPassword=").concat(model.newPassword, "&id=").concat(model.id));
  },
  resendOtp: function resendOtp(model) {
    return request('post', "api/i/v1/policy/resendOtp", model);
  }
};